import React from 'react';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import DetailListItem from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/DetailListItem';
import styles from './riskToleranceResultLayoutStyles';

const useStyles = makeStyles(styles);

export default function RiskToleranceResultLayout() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const classes = useStyles();

  return (
    <div>
      <SurveyStepHeader title={resource.attr('primaryText')} />

      <div className={classes.results}>
        {resource.attr('clients')?.resources().list().map((client) => <DetailListItem className={classes.resultItem} key={client.id()} resource={client} />)}
      </div>

      <Typography className={classes.secondaryText} color="primaryGray">{resource.attr('secondaryText')}</Typography>

      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </div>
  );
}

RiskToleranceResultLayout.propTypes = {
};

RiskToleranceResultLayout.defaultProps = {
};
